import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";

type RazaSafaiImagePreviewProps = {
  src: string;
  alt?: string;
  /** Slightly taller caps on show vs form */
  variant?: "form" | "show";
};

const frameSx: SxProps<Theme> = {
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
  borderRadius: 1,
  border: 1,
  borderColor: "divider",
  bgcolor: "action.hover",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export default function RazaSafaiImagePreview({
  src,
  alt = "Safai",
  variant = "form",
}: RazaSafaiImagePreviewProps) {
  const maxHeight =
    variant === "show" ? { xs: 280, sm: 360, md: 480 } : { xs: 200, sm: 280, md: 320 };

  return (
    <Box sx={frameSx}>
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          display: "block",
          width: "100%",
          height: "auto",
          maxHeight,
          objectFit: "contain",
        }}
      />
    </Box>
  );
}
